import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=fc6539fc&scoped=true"
import script from "./createActivity.vue?vue&type=script&lang=js"
export * from "./createActivity.vue?vue&type=script&lang=js"
import style0 from "./createActivity.vue?vue&type=style&index=0&id=fc6539fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6539fc",
  null
  
)

export default component.exports